import React, { useState } from "react";
import { MultipleOpenAccordian } from "./AccordianPanel/AccordianPanel.jsx";
import { constants } from "./AccordianPanel/common.js";
import { Col } from "react-bootstrap";
import _ from "lodash";
import PropTypes from "prop-types";

const CustomAccordion = (props) => {
  const keysToBeShownInAccordian = {
    baseScoreMetrics: "baseScore",
    ...(!props?.isDI && { temporalScoreMetrics: "temporalScore" }),
  };
  let returnVal = [];

  const getReturnVal = (obj, header) => {
    return (
      <Col style={{ marginBottom: "10px" }}>
        <h5 style={{ paddingBottom: "10px" }}>{constants[header] || header}</h5>
        <div style={{ marginLeft: "20px" }}>
          {_.map(obj, (val, key) => {
            let value = constants[key] ? constants[key] : key;
            return (
              <tr className="acc_td">
                <td>{`${value}`}</td>
                <td>:</td>
                <td>{`${val}`}</td>
              </tr>
            );
          })}
        </div>
      </Col>
    );
  };

  const getAccordianVal = (section, item) => {
    if (section && !_.isEmpty(section)) {
      const toCheckObj = Object.keys(section);
      if (typeof section[toCheckObj[0]] == "string") {
        returnVal.push(
          <tr style={{ display: "inline-block" }}>
            {getReturnVal(section, item)}
          </tr>
        );
      } else {
        let sortedKey = toCheckObj.sort();
        _.map(sortedKey, (val) => {
          getAccordianVal(section[val], val);
        });
      }
    }
    return returnVal;
  };
  const [openItems, setOpenItems] = useState({});

  const handleToggle = (id) => {
    setOpenItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  return (
    <>
      <div className="my-2">
        <span className="headerAcc1 float-left">
          <strong>{`${constants[props.version]} : ${props.cvssScore}`}</strong>
        </span>
        <span className="headerAcc2 float-right">
          <strong>
            {props?.isSbom
              ? `${constants["vulID"]} : ${props.pluginId}`
              : `${constants["plugin"]} : ${props.pluginId}`}
          </strong>
        </span>
      </div>
      <div className="my-2 Accordianens">
        {_.map(Object.keys(keysToBeShownInAccordian), (item, index) => {
          returnVal = [];
          let scoreVal = _.get(
            props,
            `sections[0].scoreDetails[${keysToBeShownInAccordian[item]}]`,
            "Not Available"
          );
          return (
            <MultipleOpenAccordian
              eventKey={index}
              openItems={openItems}
              handleToggle={handleToggle}
              header={
                constants[item]
                  ? `${constants[item]} : ${scoreVal}`
                  : `${item} : ''`
              }
              body={getAccordianVal(props.sections[0][item], item)}
            />
          );
        })}
      </div>
    </>
  );
};
CustomAccordion.propTypes = {
  isDI: PropTypes.bool,
  isSbom: PropTypes.bool,
  version: PropTypes.arrayOf(PropTypes.object).isRequired,
  cvssScore: PropTypes.arrayOf(PropTypes.object).isRequired,
  pluginId: PropTypes.arrayOf(PropTypes.object).isRequired,
  sections: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default CustomAccordion;
